<template>
  <div class="border-solid margin-bottom-10" style="width: 100%;padding: 10px;">
    <el-row>
      <el-col :span="20">
        <el-row>
          <el-col :span="12">
            <el-select
              @change="changeDevice"
              placeholder="请选择设备"
              size="mini"
              style="width: 95%;"
              v-model="pointForm.deviceId">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in deviceList">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-select
              @change="changePoint"
              placeholder="请选择测点"
              size="mini"
              style="width: 95%;"
              v-model="pointForm.pointId">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in points">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="margin-top-5" v-show="layout===2">
            <el-input placeholder="请输入名称" size="mini" style="width: 95%;" v-model="pointForm.name"></el-input>
          </el-col>
          <el-col :span="12" class="margin-top-10">
            <el-checkbox @change="changeCheckbox" v-model="pointForm.curveDisplay">曲线显示</el-checkbox>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" class="text-center">
        <el-button @touchstart="add" @click="add" size="mini" style="color: #07E6F8" v-if="index===0"> +</el-button>
        <el-button @touchstart="deleteList" @click="deleteList" size="mini" style="color: red" v-if="index!==0"> -</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {listByDeviceId} from "@/network/device-measuring-point";

export default {
  name: "pointForm",
  props: {
    index: {
      type: Number,
      required: true
    },
    layout: {
      type: Number,
      required: true
    },
    pointList: {
      type: Array,
      default: () => []
    },
    deviceList: {
      type: Array,
      default: () => []
    },
  },
  watch: {
    pointList: {
      handler(newV) {
        if (newV.length !== 0) {
          this.pointForm = newV[this.index]
        }
      },
      deep: true
    },
    pointForm: {
      handler(newV) {
        this.getPointList()
        this.$emit('uploadData', {index: this.index, data: newV})
      },
      deep: true
    },
  },
  created() {
    this.pointForm = this.pointList[this.index];
  },
  data() {
    return {
      pointForm: [],
      points: [],
    }
  },
  methods: {
    add() {
      this.$emit('add')
    },
    deleteList() {
      this.$emit('deleteIndex', this.index)
    },
    //是否曲线展示
    changeCheckbox() {
      let display = this.pointList.filter(item => item.curveDisplay).length
      if (this.layout === 1) {
        if ((this.pointForm.curveDisplay && display > 2) || (!this.pointForm.curveDisplay && display === 2)) {
          this.$message.warning("最多只能勾选两个曲线展示!")
          this.pointForm.curveDisplay = false;
        }
      }
    },
    getPointList() {
      if(this.pointForm.deviceId){
        listByDeviceId(this.pointForm.deviceId).then(res => {
          if (res.code === 0) {
            this.points = res.data;
          }
        })
      }
    },
    changeDevice() {
      const item = this._.cloneDeep(this.deviceList.filter(i => i.id === this.pointForm.deviceId)[0]);
      this.pointForm.deviceName = item.name
      this.getPointList();
      this.pointForm.pointId = null
      this.pointForm.pointCode = ''
    },
    changePoint() {
      const item = this._.cloneDeep(this.points.filter(i => i.id === this.pointForm.pointId)[0]);
      this.pointForm.pointId = item.id
      this.pointForm.pointCode = item.code
      this.pointForm.pointName = item.name
      this.pointForm.unit = item.unit
    }
  }
}
</script>

<style scoped>

</style>
